// The 16 kinds of the pinned contract, presented once: icon, navigation group, placement and
// order. `satisfies Record<Kind, …>` makes a new kind of the contract fail the build until it
// gets a row here.
import type { Kind } from "@cosmosai/specs/kinds";
import {
  BookOpenIcon,
  BotIcon,
  Building2Icon,
  ClockIcon,
  CpuIcon,
  DatabaseIcon,
  FolderIcon,
  LightbulbIcon,
  type LucideIcon,
  MessageSquareTextIcon,
  PlugIcon,
  ScanSearchIcon,
  ServerIcon,
  TargetIcon,
  UsersIcon,
  WorkflowIcon,
  WrenchIcon,
} from "lucide-react";

/** Where a kind's list sits: the Build or Resources group of the sidebar, or the scopes. */
export type KindGroup = "build" | "resources" | "scopes";

/** Where a spec of the kind lives: in a project, or at the workspace level. */
export type Placement = "project" | "workspace";

export interface KindRow {
  icon: LucideIcon;
  group: KindGroup;
  placement: Placement;
  /** Order within its group. */
  order: number;
}

export const kindTable = {
  Agent: { icon: BotIcon, group: "build", placement: "project", order: 10 },
  Prompt: { icon: MessageSquareTextIcon, group: "build", placement: "project", order: 20 },
  Orchestration: { icon: WorkflowIcon, group: "build", placement: "project", order: 30 },
  KnowledgeBase: { icon: BookOpenIcon, group: "build", placement: "project", order: 40 },
  Retriever: { icon: ScanSearchIcon, group: "build", placement: "project", order: 50 },
  Skill: { icon: LightbulbIcon, group: "build", placement: "project", order: 60 },
  EvalSuite: { icon: TargetIcon, group: "build", placement: "project", order: 70 },
  Dataset: { icon: DatabaseIcon, group: "build", placement: "project", order: 80 },
  Model: { icon: CpuIcon, group: "resources", placement: "workspace", order: 10 },
  McpServer: { icon: WrenchIcon, group: "resources", placement: "project", order: 20 },
  Connection: { icon: PlugIcon, group: "resources", placement: "workspace", order: 30 },
  Schedule: { icon: ClockIcon, group: "resources", placement: "project", order: 40 },
  Workspace: { icon: Building2Icon, group: "scopes", placement: "workspace", order: 10 },
  Team: { icon: UsersIcon, group: "scopes", placement: "workspace", order: 20 },
  Project: { icon: FolderIcon, group: "scopes", placement: "workspace", order: 30 },
  Environment: { icon: ServerIcon, group: "scopes", placement: "workspace", order: 40 },
} as const satisfies Record<Kind, KindRow>;
